<!--  -->
<template>
    <div class='bgc'>
            <el-form ref="form" label-width="80px" :inline="true">
            <el-form-item label="项目名称:">
                {{ rowData.projectName }}
            </el-form-item>

        </el-form>
        <el-form ref="form" label-width="80px" :inline="true">
            <el-form-item label="提交人:">
                {{ rowData.createBy }}
            </el-form-item>
            <el-form-item label="提交时间:">
                {{ rowData.createTime }}
            </el-form-item>

        </el-form>
        <el-form ref="form" label-width="80px" :inline="true">
            <el-form-item label="申请仪器:">
                <span>仪器名称:{{ rowData.applyIns.instrumentName }},仪器编号:{{ rowData.applyIns.serialNumber }}；</span>
                <!-- <ul>
                    <li v-for="item, index in rowData.insList" :key="index">
                        <span>仪器名称:{{ item.instrumentName }},仪器编号:{{ item.serialNumber }}；</span>
                    </li>
                </ul> -->
            </el-form-item>
        </el-form>
        <el-form ref="ruleForm" :model="form" label-width="80px"  v-if="type=='view'">
            <el-form-item label="审批操作:" >
                {{ rowData.result==1?'已通过':'已驳回' }}
            </el-form-item>
            <el-form-item label="审批意见:" >
               {{ rowData.comment||'-' }}
            </el-form-item>
            <el-form-item style="display: flex;justify-content: center;">
                <el-button @click="cancel('ruleForm')">取消</el-button>
            </el-form-item>
        </el-form>
        <el-form ref="ruleForm" :model="form" label-width="90px" :rules="rules" v-if="type=='edit'">
            <el-form-item label="审批操作:" prop="result">
                <el-radio-group v-model="form.result">
                    <el-radio :label="1">通过</el-radio>
                    <el-radio :label="2">驳回</el-radio>
                </el-radio-group>
            </el-form-item>
            <el-form-item label="驳回理由:" prop="comment" v-if="form.result==2">
                <el-input type="textarea" maxlength="300" :autosize="{ minRows: 2, maxRows: 4 }" v-model="form.comment"></el-input>
            </el-form-item>
            <el-form-item style="display: flex;justify-content: center;">
                <el-button @click="cancel('ruleForm')">取消</el-button>
                <el-button type="primary" @click="submitForm('ruleForm')">确定</el-button>
            </el-form-item>
        </el-form>

    </div>
</template>

<script>
import {
    updateReviewStream,
} from "@/api/approve.js";
export default {
    //import引入的组件需要注入到对象中才能使用
    components: {},
    props: {
        rowData: {
            type: Object,
            default: {}
        },
        type: {
            type: String,
            default: 'view'
        },
        visible:{
            type: Boolean,
            default: false
        }
    },
    data() {
        //这里存放数据
        return {
            form: {
                result: 1,
                comment: null,
            }
        };
    },
    //监听属性 类似于data概念
    computed: {
        rules(){
          return  {
                result: [
                    { required: true, message: '请选择审批操作', trigger: 'change' }
                ],
                comment: [
                    { required: this.form.result==2?true:false, message: '请填驳回理由', trigger: 'blur' }
                ]
            }
        }
    },
    //监控data中的数据变化
    watch: {
        visible:{
            immediate: true,
            deep: true,
            handler(value) {
                if(this.$refs.ruleForm){
                    this.$refs.ruleForm.resetFields();
                }
            }
        }
    },
    //方法集合
    methods: {
        cancel(formName) {
            this.$refs[formName].clearValidate();
                this.$emit('cancel')

        },
        submitForm(formName) {
            this.$refs[formName].validate((valid) => {
                if (valid) {
                    let params = {
                        id: this.rowData.id,
                        ...this.form
                    }
                    updateReviewStream(params).then(res => {
                        if (res.code == 200) {
                            this.$message({
                                message: '审批成功',
                                type: 'success'
                            });
                            this.$emit('submitForm')
                        }

                    })
                } else {
                    console.log('error submit!!');
                    return false;
                }
            });
        },
        resetForm(formName) {
            this.$refs[formName].resetFields();
        }
    },
    //生命周期 - 创建完成（可以访问当前this实例）
    created() {},
    //生命周期 - 挂载完成（可以访问DOM元素）
    mounted() {},
    beforeCreate() { }, //生命周期 - 创建之前
    beforeMount() { }, //生命周期 - 挂载之前
    beforeUpdate() { }, //生命周期 - 更新之前
    updated() { }, //生命周期 - 更新之后
    beforeDestroy() { }, //生命周期 - 销毁之前
    destroyed() { }, //生命周期 - 销毁完成
    activated() { }, //如果页面有keep-alive缓存功能，这个函数会触发
}
</script>
<style lang='less' scoped>
.bgc {

    /deep/ .el-form-item__label {
        color: #606266;
        text-align: left;
    }


}

ul {
    display: flex;
    align-items: self-start;
    flex-direction: column;

    li {
        list-style: none;
    }
}
</style>



// WEBPACK FOOTER //
// src/views/approvalManagement/components/detail.vue